import { createAsyncThunk, createSlice } from "@reduxjs/toolkit"
import axios from "../../../config/authAxios"



const initialState = { status: null, loading: false, data: [], error: "", message: "" }


export const addVoucherInStoreAction = createAsyncThunk(
    'add-Vouchers-In-Store',
    async (data, { rejectWithValue }) => {
        try {
            const res = await axios.post(`/admins/api/add-voucher`,data)
            return res?.data
        } catch (error) {
            return rejectWithValue(error.response.data)
        }
    }
)


export const addVoucherInSlice = createSlice({
    name: 'add-Vouchers-In-Store',
    initialState,
    reducers: {},
    extraReducers:
        (builder) => {
            builder.addCase(addVoucherInStoreAction.pending, (state) => {
                state.loading = true
            })
            builder.addCase(addVoucherInStoreAction.fulfilled, (state, action) => {
                state.loading = false
                state.data = action?.payload?.data
                state.status = action?.payload?.status
                state.message = action?.payload?.message
            })
            builder.addCase(addVoucherInStoreAction.rejected, (state, action) => {
                state.loading = false
                state.error = action?.payload?.error
                state.status = action?.payload?.status
                state.message = action?.payload?.message
            })
        },

})



export const addVoucherInStoreReducer = addVoucherInSlice.reducer